import { render } from "./NewCallReasons.vue?vue&type=template&id=6dea3208"
import script from "./NewCallReasons.vue?vue&type=script&lang=js"
export * from "./NewCallReasons.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__